require('../modules/es6.parse-float');
module.exports = require('../modules/_core').parseFloat;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/es6/parse-float.js
// module id = 688
// module chunks = 2